var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper-profile"},[(_vm.isLoading)?_c('div',{staticClass:"v-form"},[_vm._v("Загрузка...")]):_vm._e(),(_vm.notNotFieldIn)?_c('div',[_c('WinnerView',{attrs:{"rafflesId":_vm.rafflesId}})],1):_vm._e(),(_vm.documentStatus === 'completed')?_c('div',[_c('ThankYouView')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }